function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var t = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
function e(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function n(t, e) {
  return t(e = {
    exports: {}
  }, e.exports), e.exports;
}
var r = n(function (t, e) {
    var n;
    t.exports = (n = n || function (t, e) {
      var n = Object.create || function () {
          function t() {}
          return function (e) {
            var n;
            return t.prototype = e, n = new t(), t.prototype = null, n;
          };
        }(),
        r = {},
        o = r.lib = {},
        i = o.Base = {
          extend: function extend(t) {
            var e = n(this);
            return t && e.mixIn(t), e.hasOwnProperty("init") && this.init !== e.init || (e.init = function () {
              e.$super.init.apply(this, arguments);
            }), e.init.prototype = e, e.$super = this, e;
          },
          create: function create() {
            var t = this.extend();
            return t.init.apply(t, arguments), t;
          },
          init: function init() {},
          mixIn: function mixIn(t) {
            for (var e in t) {
              t.hasOwnProperty(e) && (this[e] = t[e]);
            }
            t.hasOwnProperty("toString") && (this.toString = t.toString);
          },
          clone: function clone() {
            return this.init.prototype.extend(this);
          }
        },
        s = o.WordArray = i.extend({
          init: function init(t, n) {
            t = this.words = t || [], this.sigBytes = n != e ? n : 4 * t.length;
          },
          toString: function toString(t) {
            return (t || c).stringify(this);
          },
          concat: function concat(t) {
            var e = this.words,
              n = t.words,
              r = this.sigBytes,
              o = t.sigBytes;
            if (this.clamp(), r % 4) for (var i = 0; i < o; i++) {
              var s = n[i >>> 2] >>> 24 - i % 4 * 8 & 255;
              e[r + i >>> 2] |= s << 24 - (r + i) % 4 * 8;
            } else for (i = 0; i < o; i += 4) {
              e[r + i >>> 2] = n[i >>> 2];
            }
            return this.sigBytes += o, this;
          },
          clamp: function clamp() {
            var e = this.words,
              n = this.sigBytes;
            e[n >>> 2] &= 4294967295 << 32 - n % 4 * 8, e.length = t.ceil(n / 4);
          },
          clone: function clone() {
            var t = i.clone.call(this);
            return t.words = this.words.slice(0), t;
          },
          random: function random(e) {
            for (var n, r = [], o = function o(e) {
                var n = 987654321,
                  r = 4294967295;
                return function () {
                  var o = ((n = 36969 * (65535 & n) + (n >> 16) & r) << 16) + (e = 18e3 * (65535 & e) + (e >> 16) & r) & r;
                  return o /= 4294967296, (o += .5) * (t.random() > .5 ? 1 : -1);
                };
              }, i = 0; i < e; i += 4) {
              var a = o(4294967296 * (n || t.random()));
              n = 987654071 * a(), r.push(4294967296 * a() | 0);
            }
            return new s.init(r, e);
          }
        }),
        a = r.enc = {},
        c = a.Hex = {
          stringify: function stringify(t) {
            for (var e = t.words, n = t.sigBytes, r = [], o = 0; o < n; o++) {
              var i = e[o >>> 2] >>> 24 - o % 4 * 8 & 255;
              r.push((i >>> 4).toString(16)), r.push((15 & i).toString(16));
            }
            return r.join("");
          },
          parse: function parse(t) {
            for (var e = t.length, n = [], r = 0; r < e; r += 2) {
              n[r >>> 3] |= parseInt(t.substr(r, 2), 16) << 24 - r % 8 * 4;
            }
            return new s.init(n, e / 2);
          }
        },
        u = a.Latin1 = {
          stringify: function stringify(t) {
            for (var e = t.words, n = t.sigBytes, r = [], o = 0; o < n; o++) {
              var i = e[o >>> 2] >>> 24 - o % 4 * 8 & 255;
              r.push(String.fromCharCode(i));
            }
            return r.join("");
          },
          parse: function parse(t) {
            for (var e = t.length, n = [], r = 0; r < e; r++) {
              n[r >>> 2] |= (255 & t.charCodeAt(r)) << 24 - r % 4 * 8;
            }
            return new s.init(n, e);
          }
        },
        l = a.Utf8 = {
          stringify: function stringify(t) {
            try {
              return decodeURIComponent(escape(u.stringify(t)));
            } catch (t) {
              throw new Error("Malformed UTF-8 data");
            }
          },
          parse: function parse(t) {
            return u.parse(unescape(encodeURIComponent(t)));
          }
        },
        f = o.BufferedBlockAlgorithm = i.extend({
          reset: function reset() {
            this._data = new s.init(), this._nDataBytes = 0;
          },
          _append: function _append(t) {
            "string" == typeof t && (t = l.parse(t)), this._data.concat(t), this._nDataBytes += t.sigBytes;
          },
          _process: function _process(e) {
            var n = this._data,
              r = n.words,
              o = n.sigBytes,
              i = this.blockSize,
              a = o / (4 * i),
              c = (a = e ? t.ceil(a) : t.max((0 | a) - this._minBufferSize, 0)) * i,
              u = t.min(4 * c, o);
            if (c) {
              for (var l = 0; l < c; l += i) {
                this._doProcessBlock(r, l);
              }
              var f = r.splice(0, c);
              n.sigBytes -= u;
            }
            return new s.init(f, u);
          },
          clone: function clone() {
            var t = i.clone.call(this);
            return t._data = this._data.clone(), t;
          },
          _minBufferSize: 0
        });
      o.Hasher = f.extend({
        cfg: i.extend(),
        init: function init(t) {
          this.cfg = this.cfg.extend(t), this.reset();
        },
        reset: function reset() {
          f.reset.call(this), this._doReset();
        },
        update: function update(t) {
          return this._append(t), this._process(), this;
        },
        finalize: function finalize(t) {
          return t && this._append(t), this._doFinalize();
        },
        blockSize: 16,
        _createHelper: function _createHelper(t) {
          return function (e, n) {
            return new t.init(n).finalize(e);
          };
        },
        _createHmacHelper: function _createHmacHelper(t) {
          return function (e, n) {
            return new p.HMAC.init(t, n).finalize(e);
          };
        }
      });
      var p = r.algo = {};
      return r;
    }(Math), n);
  }),
  o = n(function (t, e) {
    var n;
    t.exports = (n = r, function (t) {
      var e = n,
        r = e.lib,
        o = r.WordArray,
        i = r.Hasher,
        s = e.algo,
        a = [];
      !function () {
        for (var e = 0; e < 64; e++) {
          a[e] = 4294967296 * t.abs(t.sin(e + 1)) | 0;
        }
      }();
      var c = s.MD5 = i.extend({
        _doReset: function _doReset() {
          this._hash = new o.init([1732584193, 4023233417, 2562383102, 271733878]);
        },
        _doProcessBlock: function _doProcessBlock(t, e) {
          for (var n = 0; n < 16; n++) {
            var r = e + n,
              o = t[r];
            t[r] = 16711935 & (o << 8 | o >>> 24) | 4278255360 & (o << 24 | o >>> 8);
          }
          var i = this._hash.words,
            s = t[e + 0],
            c = t[e + 1],
            h = t[e + 2],
            d = t[e + 3],
            v = t[e + 4],
            g = t[e + 5],
            y = t[e + 6],
            _ = t[e + 7],
            m = t[e + 8],
            b = t[e + 9],
            w = t[e + 10],
            x = t[e + 11],
            L = t[e + 12],
            A = t[e + 13],
            O = t[e + 14],
            k = t[e + 15],
            E = i[0],
            B = i[1],
            T = i[2],
            M = i[3];
          E = u(E, B, T, M, s, 7, a[0]), M = u(M, E, B, T, c, 12, a[1]), T = u(T, M, E, B, h, 17, a[2]), B = u(B, T, M, E, d, 22, a[3]), E = u(E, B, T, M, v, 7, a[4]), M = u(M, E, B, T, g, 12, a[5]), T = u(T, M, E, B, y, 17, a[6]), B = u(B, T, M, E, _, 22, a[7]), E = u(E, B, T, M, m, 7, a[8]), M = u(M, E, B, T, b, 12, a[9]), T = u(T, M, E, B, w, 17, a[10]), B = u(B, T, M, E, x, 22, a[11]), E = u(E, B, T, M, L, 7, a[12]), M = u(M, E, B, T, A, 12, a[13]), T = u(T, M, E, B, O, 17, a[14]), E = l(E, B = u(B, T, M, E, k, 22, a[15]), T, M, c, 5, a[16]), M = l(M, E, B, T, y, 9, a[17]), T = l(T, M, E, B, x, 14, a[18]), B = l(B, T, M, E, s, 20, a[19]), E = l(E, B, T, M, g, 5, a[20]), M = l(M, E, B, T, w, 9, a[21]), T = l(T, M, E, B, k, 14, a[22]), B = l(B, T, M, E, v, 20, a[23]), E = l(E, B, T, M, b, 5, a[24]), M = l(M, E, B, T, O, 9, a[25]), T = l(T, M, E, B, d, 14, a[26]), B = l(B, T, M, E, m, 20, a[27]), E = l(E, B, T, M, A, 5, a[28]), M = l(M, E, B, T, h, 9, a[29]), T = l(T, M, E, B, _, 14, a[30]), E = f(E, B = l(B, T, M, E, L, 20, a[31]), T, M, g, 4, a[32]), M = f(M, E, B, T, m, 11, a[33]), T = f(T, M, E, B, x, 16, a[34]), B = f(B, T, M, E, O, 23, a[35]), E = f(E, B, T, M, c, 4, a[36]), M = f(M, E, B, T, v, 11, a[37]), T = f(T, M, E, B, _, 16, a[38]), B = f(B, T, M, E, w, 23, a[39]), E = f(E, B, T, M, A, 4, a[40]), M = f(M, E, B, T, s, 11, a[41]), T = f(T, M, E, B, d, 16, a[42]), B = f(B, T, M, E, y, 23, a[43]), E = f(E, B, T, M, b, 4, a[44]), M = f(M, E, B, T, L, 11, a[45]), T = f(T, M, E, B, k, 16, a[46]), E = p(E, B = f(B, T, M, E, h, 23, a[47]), T, M, s, 6, a[48]), M = p(M, E, B, T, _, 10, a[49]), T = p(T, M, E, B, O, 15, a[50]), B = p(B, T, M, E, g, 21, a[51]), E = p(E, B, T, M, L, 6, a[52]), M = p(M, E, B, T, d, 10, a[53]), T = p(T, M, E, B, w, 15, a[54]), B = p(B, T, M, E, c, 21, a[55]), E = p(E, B, T, M, m, 6, a[56]), M = p(M, E, B, T, k, 10, a[57]), T = p(T, M, E, B, y, 15, a[58]), B = p(B, T, M, E, A, 21, a[59]), E = p(E, B, T, M, v, 6, a[60]), M = p(M, E, B, T, x, 10, a[61]), T = p(T, M, E, B, h, 15, a[62]), B = p(B, T, M, E, b, 21, a[63]), i[0] = i[0] + E | 0, i[1] = i[1] + B | 0, i[2] = i[2] + T | 0, i[3] = i[3] + M | 0;
        },
        _doFinalize: function _doFinalize() {
          var e = this._data,
            n = e.words,
            r = 8 * this._nDataBytes,
            o = 8 * e.sigBytes;
          n[o >>> 5] |= 128 << 24 - o % 32;
          var i = t.floor(r / 4294967296),
            s = r;
          n[15 + (o + 64 >>> 9 << 4)] = 16711935 & (i << 8 | i >>> 24) | 4278255360 & (i << 24 | i >>> 8), n[14 + (o + 64 >>> 9 << 4)] = 16711935 & (s << 8 | s >>> 24) | 4278255360 & (s << 24 | s >>> 8), e.sigBytes = 4 * (n.length + 1), this._process();
          for (var a = this._hash, c = a.words, u = 0; u < 4; u++) {
            var l = c[u];
            c[u] = 16711935 & (l << 8 | l >>> 24) | 4278255360 & (l << 24 | l >>> 8);
          }
          return a;
        },
        clone: function clone() {
          var t = i.clone.call(this);
          return t._hash = this._hash.clone(), t;
        }
      });
      function u(t, e, n, r, o, i, s) {
        var a = t + (e & n | ~e & r) + o + s;
        return (a << i | a >>> 32 - i) + e;
      }
      function l(t, e, n, r, o, i, s) {
        var a = t + (e & r | n & ~r) + o + s;
        return (a << i | a >>> 32 - i) + e;
      }
      function f(t, e, n, r, o, i, s) {
        var a = t + (e ^ n ^ r) + o + s;
        return (a << i | a >>> 32 - i) + e;
      }
      function p(t, e, n, r, o, i, s) {
        var a = t + (n ^ (e | ~r)) + o + s;
        return (a << i | a >>> 32 - i) + e;
      }
      e.MD5 = i._createHelper(c), e.HmacMD5 = i._createHmacHelper(c);
    }(Math), n.MD5);
  }),
  i = n(function (t, e) {
    var n;
    t.exports = (n = r, function () {
      var t = n,
        e = t.lib.WordArray;
      function r(t, n, r) {
        for (var o = [], i = 0, s = 0; s < n; s++) {
          if (s % 4) {
            var a = r[t.charCodeAt(s - 1)] << s % 4 * 2,
              c = r[t.charCodeAt(s)] >>> 6 - s % 4 * 2;
            o[i >>> 2] |= (a | c) << 24 - i % 4 * 8, i++;
          }
        }
        return e.create(o, i);
      }
      t.enc.Base64 = {
        stringify: function stringify(t) {
          var e = t.words,
            n = t.sigBytes,
            r = this._map;
          t.clamp();
          for (var o = [], i = 0; i < n; i += 3) {
            for (var s = (e[i >>> 2] >>> 24 - i % 4 * 8 & 255) << 16 | (e[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 255) << 8 | e[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 255, a = 0; a < 4 && i + .75 * a < n; a++) {
              o.push(r.charAt(s >>> 6 * (3 - a) & 63));
            }
          }
          var c = r.charAt(64);
          if (c) for (; o.length % 4;) {
            o.push(c);
          }
          return o.join("");
        },
        parse: function parse(t) {
          var e = t.length,
            n = this._map,
            o = this._reverseMap;
          if (!o) {
            o = this._reverseMap = [];
            for (var i = 0; i < n.length; i++) {
              o[n.charCodeAt(i)] = i;
            }
          }
          var s = n.charAt(64);
          if (s) {
            var a = t.indexOf(s);
            -1 !== a && (e = a);
          }
          return r(t, e, o);
        },
        _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
      };
    }(), n.enc.Base64);
  }),
  s = n(function (t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.getDefaultLocale = void 0;
    e.getDefaultLocale = function () {
      var t = {
          "zh-HK": "zh-TW",
          "ko-kr": "ko",
          "tr-TR": "tr",
          "it-CH": "it",
          "it-IT": "it",
          "vi-vn": "vi",
          pt: "pt-BR",
          "pt-PT": "pt-BR",
          "pt-br": "pt-BR",
          "zh-tw": "zh-TW",
          "fil-PH": "en-PH",
          "pt-HK": "pt-BR"
        },
        e = ["zh-TW", "pt-BR", "en-PH", "pa-PK", "zh", "en", "es", "tr", "it", "fr", "ar", "th", "ru", "ja", "ko", "id", "hi", "ms", "vi", "bn", "te", "mr", "ta", "ur", "kn", "gu", "pa", "ml", "bh", "raj", "ps", "sd"],
        n = !1,
        r = navigator.language;
      if (t[r] && (r = t[r]), e.includes(r)) n = !0;else {
        var o = r.split("-")[0];
        o && e.includes(o) && (n = !0, r = o);
      }
      return n ? r : "en";
    };
  });
e(s), s.getDefaultLocale;
var a = n(function (e, n) {
  var r = t && t.__read || function (t, e) {
      var n = "function" == typeof Symbol && t[Symbol.iterator];
      if (!n) return t;
      var r,
        o,
        i = n.call(t),
        s = [];
      try {
        for (; (void 0 === e || e-- > 0) && !(r = i.next()).done;) {
          s.push(r.value);
        }
      } catch (t) {
        o = {
          error: t
        };
      } finally {
        try {
          r && !r.done && (n = i.return) && n.call(i);
        } finally {
          if (o) throw o.error;
        }
      }
      return s;
    },
    o = t && t.__spreadArray || function (t, e, n) {
      if (n || 2 === arguments.length) for (var r, o = 0, i = e.length; o < i; o++) {
        !r && o in e || (r || (r = Array.prototype.slice.call(e, 0, o)), r[o] = e[o]);
      }
      return t.concat(r || Array.prototype.slice.call(e));
    };
  Object.defineProperty(n, "__esModule", {
    value: !0
  });
  var i = function () {
    function t() {
      this.observers = {};
    }
    return t.prototype.on = function (t, e) {
      var n = this;
      return t.split(" ").forEach(function (t) {
        n.observers[t] = n.observers[t] || [], n.observers[t].push(e);
      }), this;
    }, t.prototype.off = function (t, e) {
      this.observers[t] && (e ? this.observers[t] = this.observers[t].filter(function (t) {
        return t !== e;
      }) : delete this.observers[t]);
    }, t.prototype.emit = function (t) {
      for (var e = [], n = 1; n < arguments.length; n++) {
        e[n - 1] = arguments[n];
      }
      this.observers[t] && o([], r(this.observers[t]), !1).forEach(function (t) {
        t.apply(void 0, o([], r(e), !1));
      });
      this.observers["*"] && o([], r(this.observers["*"]), !1).forEach(function (n) {
        n.apply(n, o([t], r(e), !1));
      });
    }, t;
  }();
  n.default = i;
});
e(a);
var c = n(function (t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.DEFAULT_RTL_CODES = e.DEFAULT_FALLBACL_LOCALE = void 0, e.DEFAULT_FALLBACL_LOCALE = "en", e.DEFAULT_RTL_CODES = ["ar", "ur", "pa", "ps", "sd"];
});
e(c), c.DEFAULT_RTL_CODES, c.DEFAULT_FALLBACL_LOCALE;
var u,
  l = n(function (e, n) {
    var _r,
      u = t && t.__extends || (_r = function r(t, e) {
        return _r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var n in e) {
            Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
          }
        }, _r(t, e);
      }, function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
        function n() {
          this.constructor = t;
        }
        _r(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
      }),
      l = t && t.__assign || function () {
        return l = Object.assign || function (t) {
          for (var e, n = 1, r = arguments.length; n < r; n++) {
            for (var o in e = arguments[n]) {
              Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
            }
          }
          return t;
        }, l.apply(this, arguments);
      },
      f = t && t.__read || function (t, e) {
        var n = "function" == typeof Symbol && t[Symbol.iterator];
        if (!n) return t;
        var r,
          o,
          i = n.call(t),
          s = [];
        try {
          for (; (void 0 === e || e-- > 0) && !(r = i.next()).done;) {
            s.push(r.value);
          }
        } catch (t) {
          o = {
            error: t
          };
        } finally {
          try {
            r && !r.done && (n = i.return) && n.call(i);
          } finally {
            if (o) throw o.error;
          }
        }
        return s;
      },
      p = t && t.__spreadArray || function (t, e, n) {
        if (n || 2 === arguments.length) for (var r, o = 0, i = e.length; o < i; o++) {
          !r && o in e || (r || (r = Array.prototype.slice.call(e, 0, o)), r[o] = e[o]);
        }
        return t.concat(r || Array.prototype.slice.call(e));
      },
      h = t && t.__importDefault || function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      };
    Object.defineProperty(n, "__esModule", {
      value: !0
    });
    var d = h(o),
      v = h(i),
      g = h(a),
      y = function y() {},
      _ = 0,
      m = function (t) {
        function e(e) {
          var n,
            r = this;
          return (r = t.call(this) || this).plugins = {}, r.messagesMeta = {}, r.baseTransformMessages = function (t) {
            var e = t || {},
              n = e.language,
              r = void 0 === n ? [] : n,
              o = e.textList,
              i = void 0 === o ? [] : o;
            return r.reduce(function (t, e, n) {
              var r = {};
              return i.forEach(function (t) {
                var e = t.key,
                  o = void 0 === e ? "" : e,
                  i = t.hash,
                  s = void 0 === i ? "" : i,
                  a = t.text,
                  c = void 0 === a ? [] : a;
                r[o] = c[n], r[s] = c[n];
              }), t[e] = l({}, r), t;
            }, {});
          }, r.options = e, r.locale = e.locale || (0, s.getDefaultLocale)(), r.fallbackLocale = e.fallbackLocale || c.DEFAULT_FALLBACL_LOCALE, e.messages = null !== (n = e.messages) && void 0 !== n ? n : {}, r._messages = r.processMessages(e.messages), r.extractMeta(e.messages), r.formatter = e.formatter || [], Array.isArray(e.plugins) && e.plugins.forEach(function (t) {
            "object" == _typeof(t) && "function" == typeof t.apply && r.use(t);
          }), e.events && Object.keys(e.events).forEach(function (t) {
            var n,
              o = (null === (n = e.events) || void 0 === n ? void 0 : n[t]) || y;
            r.on(t, o);
          }), r.handleRtl(), r;
        }
        return u(e, t), Object.defineProperty(e.prototype, "messages", {
          get: function get() {
            return this._messages;
          },
          set: function set(t) {
            this._messages = t, this.emit("MESSAGES_CHANGED", t);
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "isRtl", {
          get: function get() {
            return this.getIsRtl();
          },
          enumerable: !1,
          configurable: !0
        }), e.prototype.handleRtl = function () {
          var t, e, n, r, o, i, s, a, c;
          if (null === (t = this.options.rtl) || void 0 === t ? void 0 : t.watcher) {
            if (this.isRtl && (null === (n = null === (e = this.options.rtl) || void 0 === e ? void 0 : e.watcher) || void 0 === n ? void 0 : n.on)) return void (null === (o = null === (r = this.options.rtl) || void 0 === r ? void 0 : r.watcher) || void 0 === o || o.on());
            if (!this.isRtl && (null === (s = null === (i = this.options.rtl) || void 0 === i ? void 0 : i.watcher) || void 0 === s ? void 0 : s.off)) return void (null === (c = null === (a = this.options.rtl) || void 0 === a ? void 0 : a.watcher) || void 0 === c || c.off());
          }
        }, e.prototype.getIsRtl = function () {
          var t, e, n, r;
          if (null === (t = this.options.rtl) || void 0 === t ? void 0 : t.handler) return null === (e = this.options.rtl) || void 0 === e ? void 0 : e.handler(this.locale);
          if (null === (n = this.options.rtl) || void 0 === n ? void 0 : n.codes) {
            var o = (null === (r = this.options.rtl) || void 0 === r ? void 0 : r.codes) || [];
            return p(p([], f(c.DEFAULT_RTL_CODES), !1), f(o), !1).indexOf(this.locale) > -1;
          }
          return c.DEFAULT_RTL_CODES.indexOf(this.locale) > -1;
        }, e.prototype.extractMeta = function (t) {
          Array.isArray(t) && (t = t[0]), t && (this.messagesMeta = {
            config: t.config,
            timestamp: t.timestamp
          });
        }, e.prototype.use = function (t) {
          if (t) {
            var e = t.key || t.constructor && t.constructor.key || "plugin_auto_key_".concat(_++);
            "function" != typeof t.apply || t.k18n && t.k18n === this || t.apply(this), this.plugins[e] = t;
          }
        }, e.prototype.genHash = function (t) {
          var e = t.text,
            n = void 0 === e ? "" : e,
            r = t.desc,
            o = void 0 === r ? "" : r,
            i = "<<text:>>".concat(n, "<<desc:>>").concat(o);
          return (0, d.default)(i).toString(v.default);
        }, e.prototype.baseMergeMessagesObj = function (t) {
          return t.reduce(function (t, e) {
            var n = p(p([], f(Object.keys(t)), !1), f(Object.keys(e)), !1),
              r = {};
            return n.forEach(function (n) {
              r[n] = Object.assign(t[n] || {}, e[n] || {});
            }), r;
          }, {});
        }, e.prototype.processMessages = function (t) {
          var e = this;
          Array.isArray(t) || (t = [t]);
          var n = t.map(function (t) {
            return e.baseTransformMessages(t);
          });
          return this.baseMergeMessagesObj(n);
        }, e.prototype.addMessages = function (t) {
          var e = this.baseTransformMessages(l({}, t));
          this.messages = this.baseMergeMessagesObj([this.messages, e]);
        }, e.prototype.changeLocale = function (t) {
          this.locale = t, this.emit("LOCALE_CHANGED", t), this.handleRtl();
        }, e.prototype.changeFallbackLocale = function (t) {
          this.fallbackLocale = t, this.emit("FALLBACK_LOCALE_CHANGED", t);
        }, e.prototype.getLangByKeyOrText = function (t, e) {
          if (!t) return "";
          var n = this.messages,
            r = e.locale || this.locale,
            o = e.fallbackLocale || this.fallbackLocale,
            i = n[r] && n[r][t];
          return i || (i = this.messages[o] && this.messages[o][t]), i ? e.params ? this.injectParams(i, e.params) : i : "";
        }, e.prototype.injectParams = function (t, e) {
          return Object.keys(e || {}).forEach(function (n) {
            var r = new RegExp("\\$\\{".concat(n, "\\}"), "g"),
              o = new RegExp("\\{".concat(n, "\\}\\$"), "g"),
              i = new RegExp("\\{".concat(n, "\\}"), "g");
            t = t.replace(r, "".concat(e[n])).replace(o, "".concat(e[n])).replace(i, "".concat(e[n]));
          }), t;
        }, e.prototype.postFormatter = function (t) {
          var e = this.formatter,
            n = t;
          return (void 0 === e ? [] : e).forEach(function (t) {
            "function" == typeof t.interpolate && ("" !== (n = t.interpolate(n)) && void 0 !== n || (console.warn("[k18n formatter warning]: ".concat(t.name || "unknown formatter", " formatter 的返回值为空， 请检查是否有错误")), n = ""));
          }), n;
        }, e.prototype.getText = function (t, e) {
          e = e || {};
          var n = (e = "string" == typeof t ? Object.assign(e, {
              text: t
            }) : t).id,
            r = "";
          if (r || (r = this.getLangByKeyOrText(n, e)), !r) {
            var o = this.genHash(e);
            r = this.getLangByKeyOrText(o, e);
          }
          return r || (r = this.getLangByKeyOrText(e.text, e)), r ? this.postFormatter(r) : (console.warn("通过 key: ".concat(e.id || "", ", text: ").concat(e.text || "", ", desc: ").concat(e.desc || "", " 无法查询到文案，请检查")), this.injectParams(e.id || e.text || "", e.params || {}));
        }, e;
      }(g.default);
    n.default = m;
  }),
  f = e(l),
  p = {
    render: function render() {
      var t = this,
        e = t.$createElement;
      return (t._self._c || e)("span", [t._v(t._s(t.getText()))]);
    },
    staticRenderFns: [],
    name: "k18n",
    props: {
      id: String,
      text: String,
      desc: String,
      params: Object
    },
    methods: {
      _getSlotText: function _getSlotText() {
        return this.$slots.default && this.$slots.default.length > 0 ? this.$slots.default[0].text : "";
      },
      getText: function getText() {
        var t = this._getSlotText();
        return this.$k18n({
          id: this.id,
          text: void 0 === this.text ? t : this.text,
          desc: this.desc,
          params: this.params
        });
      }
    }
  },
  h = !1,
  d = {
    install: function install(t, e) {
      if (!h) {
        h = !0;
        var n = new f(e);
        u = n;
        var r = n.getText.bind(n);
        r.global = n, t.component("k18n", p), t.mixin({
          data: function data() {
            return {
              k18n: r.global
            };
          },
          provide: function provide() {
            return {
              $k18n: r
            };
          }
        }), t.prototype.$k18n = r, window.__$k18n = r;
      }
    }
  };
function v(t, e) {
  t.component("k18n", p);
  var n = new f(e),
    r = n.getText.bind(n);
  return u = n, r.global = n, t.prototype.$k18n = r, window.__$k18n = r, t.mixin({
    data: function data() {
      return {
        k18n: r.global
      };
    },
    provide: function provide() {
      return {
        $k18n: r
      };
    }
  }), r;
}
function g(t, e) {
  var n = new f(e),
    r = n.getText.bind(n);
  return r.global = n, window.__$k18n = r, r;
}
var y = function y() {
  return u;
};
export { d as Vue2K18nNext, v as createK18n, g as createK18nReader, y as getCurrentInstance };